export enum SelectionAssistantType {
  ROTARY = "ROTARY",
  HOUSINGS = "HOUSINGS",
  LINEAR = "LINEAR",
}
